import React from "react";
export default function SmallText(props) {
  let lengthtxt = props.lengthText ? props.lengthText : 50;
  let text =
    props.children.length > lengthtxt
      ? props.children.substring(0, lengthtxt).toLowerCase() + "..."
      : props.children.toLowerCase();
  return <div title={props.children}>{text}</div>;
}
